import { makePort } from './makePort';

export const OutputPort = makePort('Circle', {
  fromLinkable: true,
  fromMaxLinks: 1,
  name: 'OUTPUTPORT',
});
